<template>
  <div class="card card-form mb-3">
    <div class="card-header" v-if="property.affiliate.properties_count > 1">
      {{ property.name }}
    </div>
    <div class="card-body pb-1">

      <div class="pb-3">
        <h2>
          <font-awesome-icon icon="key"/>
          Affiliate data
        </h2>

        <input-control
          label="Widget URL"
          :readonly="true"
          :value="websiteLink(`widget/${property.uuid}`)">
          Använd denna länk för att infoga widgeten på er hemsida med hjälp av iFrame. Se vidare information för hur ni integrerar widgeten på <router-link :to="{name: 'documentation'}">dokumentationsfliken</router-link>
        </input-control>

        <hr>

        <input-control
          label="Affiliate-länk"
          :readonly="true"
          :value="websiteLink(`?affiliate=${property.uuid}`)">
          Använd affiliate-länken för att dirigera trafik till vår hemsida. Läs mer om hur affiliate-länkning fungerar på vår <router-link :to="{name: 'documentation'}">dokumentationshemsida</router-link>
        </input-control>
      </div>

      <div class="pb-3">

        <h2>
          <font-awesome-icon icon="file-code"/>
          Widget-anpassning
        </h2>

        <div class="alert alert-info">
          <a :href="websiteLink(`widget/${property.uuid}`)" target="_blank" class="btn btn-light btn-sm mr-3">
            <font-awesome-icon icon="external-link-alt"/>
            Förhandsgranska widget
          </a>

          <small class="text-muted">
            Kommer öppnas i en ny flik. Vänligen kontrollera att du sparar eventuella ändringar innan du förhandsgranskar
          </small>
        </div>

        <div class="row">
          <div class="col-sm-4">

            <input-control
              label="Bakgrundsfärg"
              prefix="#"
              placeholder="Color code in XXXXXX format"
              :error="vError('background_color')"
              v-model="background_color"/>

          </div>

          <div class="col-sm-4">

            <input-control
              label="Ange färg för knapp"
              prefix="#"
              placeholder="Color code in XXXXXX format"
              :error="vError('button_color')"
              v-model="button_color"/>

          </div>

        </div>

        <input-control
          prefix=".button {"
          postfix="}"
          label="Extra CSS"
          :error="vError('button_extra_css')"
          v-model="button_extra_css"/>

        <div class="text-center">
          <button class="btn btn-success" @click="save">
            Spara
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import InputControl from "../../Partials/Controls/Input"
  import DataValidator from "../../../app/mixins/Validation/DataValidator"

  export default {
    name: "PropertyItem",
    components: {InputControl},
    mixins: [
      DataValidator()
    ],
    props: {
      property: {
        required: true,
        format: Object
      }
    },
    mounted(){
      this.background_color = this.property.background_color
      this.button_color = this.property.button_color
      this.button_extra_css = this.property.button_extra_css
    },
    methods: {
      validationRules() {
        return [
          {
            name: 'background_color',
            rules: 'length:6'
          },
          {
            name: 'button_color',
            rules: 'length:6'
          },
          {
            name: 'button_extra_css',
            rules: ''
          },
        ]
      },
      async save() {
        if (await this.validate(this.$data) === false) {
          return
        }

        this.showLoader()

        await this.$store.dispatch('properties/update', {
          uuid: this.property.uuid,
          payload: this.$data
        })

        this.hideLoader()
      }
    },
    data(){
      return {
        background_color: null,
        button_color: null,
        button_extra_css: null,
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Settings/Property.vue